import classnames from 'classnames/bind'
import React from 'react'

// Components
// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes

export type TButtonProps = {
  children: React.ReactNode
  className?: string
  elementType?: 'button' | 'submit' | 'reset'
  isFetching?: boolean
  theme?: 'major' | 'secondary' | 'pink' | 'white'
  size?: 'sm' | 'md' | 'lg'
  disabled?: boolean
  isLoading?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  styles?: React.CSSProperties
  elementRef?: React.RefObject<HTMLButtonElement>
}

function Button(props: TButtonProps) {
  const { children, className, elementType = 'button', theme = 'major', size = 'sm', styles, disabled, elementRef, ...restProps } = props

  return (
    <button
      className={cx('button', className)}
      data-theme={theme}
      data-size={size}
      type={elementType}
      disabled={disabled}
      style={styles}
      ref={elementRef}
      {...restProps}
    >
      {children}
    </button>
  )
}

export default Button
